import { Observable } from 'rxjs';
import { AppState, AuthState } from '../../state';
import { AuthInterceptorBase } from './auth-interceptor-base';

export class HeadlessAuthInterceptor extends AuthInterceptorBase {
  private currentUserId: string;

  constructor() {
    super();
    this.store
      .select(AuthState.userId)
      .subscribe((userId) => (this.currentUserId = userId));
  }

  override setTimeZoneOffset(): void {
    this._timeZoneOffset =
      this.store.selectSnapshot(AppState.headlessConfig)?.timeZoneOffset ||
      new Date().getTimezoneOffset() * -1;
  }

  // Send as bearer token
  override setTokenHeader(token: string): {
    headerKey: string;
    headerValue: string;
  } {
    return {
      headerKey: 'Authorization',
      headerValue: `Bearer ${token}`,
    };
  }

  override setAdditionalHeaders(): Array<{
    headerKey: string;
    headerValue: string;
  }> {
    return [
      {
        headerKey: 'X-USER-ID',
        headerValue: this.currentUserId,
      },
    ];
  }

  override getAccessToken(): Observable<string> {
    return this.authService.getAccessToken();
  }
}
